import * as API from '@/api';
import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';

function initialState () {
  return {
    list: null,
  };
}

const state = initialState ();

// getters
const getters = {
  getField,
  list: state => {
    return state.list;
  },
};

// actions
const actions = {
  async get (context, payload) {
    var response = await API.consumer.get (payload);
    return response;
  },

  async update (context, payload) {
    var response = await API.consumer.update (payload);
    return response;
  },

  async getConsumerList (context, payload) {
    var response = await API.consumer.getConsumerList (payload);
    return response;
  },

  /** Get all consumers available on company */
  async getAllConsumerList (context, payload) {
    var response = await API.consumer.getAllConsumerList (payload);
    context.commit ('set_list', {
      consumers: response.consumers,
    });
    return response;
  },

  async showPassword (context, payload) {
    var response = await API.consumer.showPassword (payload);
    return response;
  },

  async sendReminders (context, payload) {
    var response = await API.consumer.sendReminders (payload);
    return response;
  },

  async detachConsumer (context, payload) {
    var response = await API.consumer.detachConsumer (payload);
    return response;
  },

  async detachAllConsumer (context, payload) {
    var response = await API.consumer.detachAllConsumer (payload);
    return response;
  },

  async createByAdmin (context, payload) {
    var response = await API.consumer.createByAdmin (payload);
    return response;
  },

  async refund (context, payload) {
    var response = await API.consumer.refund (payload);
    context.commit ('monetization/update_purchase', response, DEFINES.USE_ROOT);
    return response;
  },

  async exportReport (context, payload) {
    var response = await API.consumer.exportReport (payload);
    return response;
  },

  async exportAllConsumersReport (context, payload) {
    var response = await API.consumer.exportAllConsumersReport (payload);
    return response;
  },

  async redeemCoupon (context, payload) {
    var response = await API.consumer.redeemCoupon (payload);
    return response;
  },
};

// mutations
const mutations = {
  updateField,
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },

  set_list (state, payload) {
    state.list = payload.consumers;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
